<template>
    <div>
      <Loader :is-visible="isLoading"></Loader>
      <div class="grid">
          <div class="sidebar">
            <div class="sidebar__menu">
              <ul class="sidebar__list">
                <router-link to="/">
                  <li
                    class="sidebar__list-item list--item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 14.828v9.172h18v-9.172l-9-8.375-9 8.375zm11 7.172h-4v-6h4v6zm10-9.852l-1.361 1.465-10.639-9.883-10.639 9.868-1.361-1.465 12-11.133 12 11.148z"/></svg>
                    </span>
                    Home
                  </li>
                </router-link>
                <router-link to="#">
                <li
                  class="sidebar__list-item list--item"
                  @click="dropIt"
                  >
                  <span>
                    <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 12h-10v1h10v-1zm-4 2h-6v1h6v-1zm4-6h-10v1h10v-1zm0 2h-10v1h10v-1zm0-6h-10v1h10v-1zm0 2h-10v1h10v-1zm7.44 10.277c.183-2.314-.433-2.54-3.288-5.322.171 1.223.528 3.397.911 5.001.089.382-.416.621-.586.215-.204-.495-.535-2.602-.82-4.72-.154-1.134-1.661-.995-1.657.177.005 1.822.003 3.341 0 6.041-.003 2.303 1.046 2.348 1.819 4.931.132.444.246.927.339 1.399l3.842-1.339c-1.339-2.621-.693-4.689-.56-6.383zm-6.428 1.723h-13.012v-16h14v7.894c.646-.342 1.348-.274 1.877.101l.123-.018v-8.477c0-.828-.672-1.5-1.5-1.5h-15c-.828 0-1.5.671-1.5 1.5v17c0 .829.672 1.5 1.5 1.5h13.974c-.245-.515-.425-1.124-.462-2z"/></svg>
                  </span>
                  Tentang
                  <span id="about" class="sidebar__icon-drop">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/></svg>
                  </span>
                </li>
                  <transition name="slide">
                    <ul class="sub-menu" v-if="subMenu">
                      <router-link to="/tentang-galeri">
                        <li
                          class="sidebar__list-item sub-menu__sub--item">
                          Embed
                        </li>
                      </router-link>
                      <router-link to="/tentang-visi-misi">
                        <li
                          class="sidebar__list-item">
                          Visi & Misi
                        </li>
                      </router-link>
                      <router-link to="/ketua-umum">
                        <li
                          class="sidebar__list-item">
                          Ketua Umum
                        </li>
                      </router-link>
                      <router-link to="/filosofi-logo">
                        <li
                          class="sidebar__list-item">
                          Filosofi Logo
                        </li>
                      </router-link>
                      <router-link to="/pemilu-periode">
                        <li
                          class="sidebar__list-item">
                          Pemilu & Periode
                        </li>
                      </router-link>
                    </ul>
                  </transition>
                </router-link>
                <router-link to="/bagian-perindo">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M17.997 18h-11.995l-.002-.623c0-1.259.1-1.986 1.588-2.33 1.684-.389 3.344-.736 2.545-2.209-2.366-4.363-.674-6.838 1.866-6.838 2.491 0 4.226 2.383 1.866 6.839-.775 1.464.826 1.812 2.545 2.209 1.49.344 1.589 1.072 1.589 2.333l-.002.619zm4.811-2.214c-1.29-.298-2.49-.559-1.909-1.657 1.769-3.342.469-5.129-1.4-5.129-1.265 0-2.248.817-2.248 2.324 0 3.903 2.268 1.77 2.246 6.676h4.501l.002-.463c0-.946-.074-1.493-1.192-1.751zm-22.806 2.214h4.501c-.021-4.906 2.246-2.772 2.246-6.676 0-1.507-.983-2.324-2.248-2.324-1.869 0-3.169 1.787-1.399 5.129.581 1.099-.619 1.359-1.909 1.657-1.119.258-1.193.805-1.193 1.751l.002.463z"/>
                      </svg>
                    </span>
                    Tokoh Perindo
                  </li>
                </router-link>
                <router-link to="/agenda-perindo">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M17 3v-2c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1zm-12 1c.553 0 1-.448 1-1v-2c0-.552-.447-1-1-1-.553 0-1 .448-1 1v2c0 .552.447 1 1 1zm13 13v-3h-1v4h3v-1h-2zm-5 .5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5-4.5 2.019-4.5 4.5zm11 0c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5zm-14.237 3.5h-7.763v-13h19v1.763c.727.33 1.399.757 2 1.268v-9.031h-3v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-9v1c0 1.316-1.278 2.339-2.658 1.894-.831-.268-1.342-1.111-1.342-1.984v-.91h-3v21h11.031c-.511-.601-.938-1.273-1.268-2z"/></svg>
                    </span>
                    Perindo Agenda
                  </li>
                </router-link> 
                <router-link to="/aspirasi-perindo">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M3.732 13h1.504s2.32-8.403 2.799-10.263c.156-.605.646-.738.965-.737.319.001.826.224.947.74.581 2.466 3.11 13.908 3.11 13.908s1.597-6.441 1.943-7.891c.101-.425.536-.757 1-.757.464 0 .865.343 1 .707.312.841 1.675 4.287 1.677 4.293h1.591c.346-.598.992-1 1.732-1 1.104 0 2 .896 2 2s-.896 2-2 2c-.741 0-1.388-.404-1.734-1.003-.939-.001-1.856 0-2.266.003-.503.004-.774-.289-.928-.629l-.852-2.128s-1.828 7.367-2.25 8.999c-.153.595-.646.762-.97.758-.324-.004-.847-.198-.976-.783-.549-2.487-2.081-9.369-3.123-14.053 0 0-1.555 5.764-1.936 7.099-.13.454-.431.731-.965.737h-2.268c-.346.598-.992 1-1.732 1-1.104 0-2-.896-2-2s.896-2 2-2c.74 0 1.386.402 1.732 1z"/></svg>
                    </span>
                    Aspirasi
                  </li>
                </router-link>
                <router-link to="/berita-perindo">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M14.078 4.232l-12.64 12.639-1.438 7.129 7.127-1.438 12.641-12.64-5.69-5.69zm-10.369 14.893l-.85-.85 11.141-11.125.849.849-11.14 11.126zm2.008 2.008l-.85-.85 11.141-11.125.85.85-11.141 11.125zm18.283-15.444l-2.816 2.818-5.691-5.691 2.816-2.816 5.691 5.689z"/></svg>
                    </span>
                    Berita Perindo
                  </li>
                </router-link>
                <router-link to="/sayap-perindo">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 16h13v1h-13v-1zm13-3h-13v1h13v-1zm0-6h-5v1h5v-1zm0 3h-5v1h5v-1zm-17-8v17.199c0 .771-1 .771-1 0v-15.199h-2v15.98c0 1.115.905 2.02 2.02 2.02h19.958c1.117 0 2.022-.904 2.022-2.02v-17.98h-21zm19 17h-17v-15h17v15zm-9-12h-6v4h6v-4z"/></svg>
                    </span>
                    Sayap Perindo
                  </li>
                </router-link>
                <router-link to="/galeri-perindo">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 12c0-.552.448-1 1.001-1s.999.448.999 1-.446 1-.999 1-1.001-.448-1.001-1zm6.2 0l-1.7 2.6-1.3-1.6-3.2 4h10l-3.8-5zm5.8-7v-2h-21v15h2v-13h19zm3 2v14h-20v-14h20zm-2 2h-16v10h16v-10z"/></svg>
                    </span>
                    Galeri Perindo
                  </li>
                </router-link>
                <router-link to="/dpp">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10.644 17.08c2.866-.662 4.539-1.241 3.246-3.682-3.932-7.427-1.042-11.398 3.111-11.398 4.235 0 7.054 4.124 3.11 11.398-1.332 2.455.437 3.034 3.242 3.682 2.483.574 2.647 1.787 2.647 3.889v1.031h-18c0-2.745-.22-4.258 2.644-4.92zm-12.644 4.92h7.809c-.035-8.177 3.436-5.313 3.436-11.127 0-2.511-1.639-3.873-3.748-3.873-3.115 0-5.282 2.979-2.333 8.549.969 1.83-1.031 2.265-3.181 2.761-1.862.43-1.983 1.34-1.983 2.917v.773z"/></svg>
                    </span>
                    DPP
                  </li>
                </router-link>
                <router-link to="/dpw">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10.644 17.08c2.866-.662 4.539-1.241 3.246-3.682-3.932-7.427-1.042-11.398 3.111-11.398 4.235 0 7.054 4.124 3.11 11.398-1.332 2.455.437 3.034 3.242 3.682 2.483.574 2.647 1.787 2.647 3.889v1.031h-18c0-2.745-.22-4.258 2.644-4.92zm-12.644 4.92h7.809c-.035-8.177 3.436-5.313 3.436-11.127 0-2.511-1.639-3.873-3.748-3.873-3.115 0-5.282 2.979-2.333 8.549.969 1.83-1.031 2.265-3.181 2.761-1.862.43-1.983 1.34-1.983 2.917v.773z"/></svg>
                    </span>
                    DPW
                  </li>
                </router-link>
                <router-link to="/dpd">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg alt="https://iconmonstr.com/" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M10.644 17.08c2.866-.662 4.539-1.241 3.246-3.682-3.932-7.427-1.042-11.398 3.111-11.398 4.235 0 7.054 4.124 3.11 11.398-1.332 2.455.437 3.034 3.242 3.682 2.483.574 2.647 1.787 2.647 3.889v1.031h-18c0-2.745-.22-4.258 2.644-4.92zm-12.644 4.92h7.809c-.035-8.177 3.436-5.313 3.436-11.127 0-2.511-1.639-3.873-3.748-3.873-3.115 0-5.282 2.979-2.333 8.549.969 1.83-1.031 2.265-3.181 2.761-1.862.43-1.983 1.34-1.983 2.917v.773z"/></svg>
                    </span>
                    DPD
                  </li>
                </router-link>
                <router-link to="/document-perindo">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6 22v-16h16v7.543c0 4.107-6 2.457-6 2.457s1.518 6-2.638 6h-7.362zm18-7.614v-10.386h-20v20h10.189c3.163 0 9.811-7.223 9.811-9.614zm-10 1.614h-5v-1h5v1zm5-4h-10v1h10v-1zm0-3h-10v1h10v-1zm2-7h-19v19h-2v-21h21v2z"/></svg>
                    </span>
                    Document
                  </li>
                </router-link>
                <router-link to="/member-report">
                  <li
                    class="sidebar__list-item">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20 0v2h-18v18h-2v-20h20zm3.889 22.333l-4.76-4.761c.51-.809.809-1.764.809-2.791 0-2.9-2.35-5.25-5.25-5.25s-5.25 2.35-5.25 5.25 2.35 5.25 5.25 5.25c1.027 0 1.982-.299 2.791-.809l4.761 4.76 1.649-1.649zm-13.201-7.552c0-2.205 1.795-4 4-4s4 1.795 4 4-1.795 4-4 4-4-1.795-4-4zm6.74 7.219h-11.428v-16h16v11.615l2 2v-15.615h-20v20h15.428l-2-2z"/></svg>
                    </span>
                    Member Report
                  </li>
                </router-link>
                <br>
                <br>
                <li
                  class="sidebar__list-item" @click="logout()">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8 10v-5l8 7-8 7v-5h-8v-4h8zm2-8v2h12v16h-12v2h14v-20h-14z"/></svg>
                  </span>
                  Logout
                </li>
              </ul>
            </div>
          </div>
          <router-view/>
      </div>
    </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import axios from 'axios';

export default {
  name: 'App',
   data () {
    return {
       isLoading: false,
       subMenu: false,
    }
  },
  methods: {
    dropIt() {
      this.subMenu = !this.subMenu
      const rotate = document.querySelector('#about')
      console.log('rotate', rotate.classList)
      if(rotate.classList.contains('icon-rotate')) {
        rotate.classList.remove('icon-rotate')
      } else {
        rotate.classList.add('icon-rotate')
      }
      // rotate.classList()
    },
    async logout() {
      try {
          this.isLoading = true
          const params = new URLSearchParams()
          let token = localStorage.getItem('token')

          params.append('token', token)

          const config = {
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              }
          }
          const response = await axios.post('/auth/logout', params, config)
          this.isLoading = false

          console.log(response)
          if(response.status == 200) {
              localStorage.clear()
              this.$router.push('/login')
          }

      } catch (err) {
          console.log(err)
      }
    }
  },
  components: {
      Loader
  },
}
</script>